// Owner in P2: piece 15 "Pipeline" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): `/pipeline`, one lazy chunk.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { SquareKanban } from 'lucide-react'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  app: (parent) => [createRoute({ getParentRoute: () => parent, path: '/pipeline', component: lazyRouteComponent(() => import('./PipelineScreen.tsx')) })],
  nav: [{ to: '/pipeline', label: 'nav.pipeline', icon: SquareKanban, group: 'work', key: 'd' }],
}
